module.exports = __webpack_public_path__ + "static/media/video_2.a8967a6.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_10/video_2.mp4
// module id = jryo
// module chunks = 0